/* eslint-disable */
import plugin from 'tailwindcss/plugin';
import config from './config';

export default plugin(
  ({ addComponents, theme }) => {
    addComponents(getGridComponent(theme));
    addComponents(getRowComponent(theme));
    addComponents(getColComponent(theme));
    addComponents(getFlexWrapperComponent());
  },
  {
    theme: {
      flexboxgrid: config
    }
  }
);

const getGridComponent = (theme) => {
  return {
    '.pff-flexbox-grid': {
      marginRight: 'auto',
      marginLeft: 'auto',
      paddingRight: `${theme('flexboxgrid.outerMargin')}rem`,
      paddingLeft: `${theme('flexboxgrid.outerMargin')}rem`,

      '@screen sm': {
        width: `${theme('flexboxgrid.container.sm')}rem`
      },
      '@screen md': {
        width: `${theme('flexboxgrid.container.md')}rem`
      },
      '@screen lg': {
        width: `${theme('flexboxgrid.container.lg')}rem`
      },

      '&--fluid': {
        width: 'auto'
      }
    }
  };
};

const getRowComponent = (theme) => {
  return {
    '.pff-flexbox-row': {
      boxSizing: 'border-box',
      display: 'flex',
      flex: '0 1 auto',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginRight: `${(theme('flexboxgrid.gutterWidth') / 2) * -1}rem`,
      marginLeft: `${(theme('flexboxgrid.gutterWidth') / 2) * -1}rem`,

      '&--reverse': {
        flexDirection: 'row-reverse'
      },

      '&--start': {
        justifyContent: 'flex-start'
      },

      '&--center': {
        justifyContent: 'center'
      },

      '&--end': {
        justifyContent: 'flex-end'
      },

      '&--top': {
        alignItems: 'flex-start'
      },

      '&--middle': {
        alignItems: 'center'
      },

      '&--bottom': {
        alignItems: 'flex-end'
      },

      '&--around': {
        justifyContent: 'space-around'
      },

      '&--between': {
        justifyContent: 'space-between'
      },

      '&--first': {
        order: -1
      },

      '&--last': {
        order: 1
      }
    }
  };
};

const getColComponent = (theme) => {
  return {
    '.pff-flexbox-column': {
      boxSizing: 'border-box',
      flex: '0 0 auto',
      paddingRight: `${theme('flexboxgrid.gutterWidth') / 2}rem`,
      paddingLeft: `${theme('flexboxgrid.gutterWidth') / 2}rem`,

      '&--show': {
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: '100%',
        display: 'block'
      },

      '&--reverse': {
        display: 'flex',
        flexDirection: 'column-reverse'
      },

      // gridSize: mobile: 8, tablet: 8
      '&--1\\/8': {
        display: 'block',
        maxWidth: '12.5%',
        flexBasis: '12.5%'
      },

      '&--2\\/8': {
        display: 'block',
        maxWidth: '25%',
        flexBasis: '25%'
      },

      '&--3\\/8': {
        display: 'block',
        maxWidth: '37.5%',
        flexBasis: '37.5%'
      },

      '&--4\\/8': {
        display: 'block',
        maxWidth: '50%',
        flexBasis: '50%'
      },

      '&--5\\/8': {
        display: 'block',
        maxWidth: '62.5%',
        flexBasis: '62.5%'
      },

      '&--6\\/8': {
        display: 'block',
        maxWidth: '75%',
        flexBasis: '75%'
      },

      '&--7\\/8': {
        display: 'block',
        maxWidth: '87.5%',
        flexBasis: '87.5%'
      },

      '&--8\\/8': {
        display: 'block',
        maxWidth: '100%',
        flexBasis: '100%'
      },

      // gridSize: laptop: 10
      '&--1\\/10': {
        display: 'block',
        maxWidth: '10%',
        flexBasis: '10%'
      },

      '&--2\\/10': {
        display: 'block',
        maxWidth: '20%',
        flexBasis: '20%'
      },

      '&--3\\/10': {
        display: 'block',
        maxWidth: '30%',
        flexBasis: '30%'
      },

      '&--4\\/10': {
        display: 'block',
        maxWidth: '40%',
        flexBasis: '40%'
      },

      '&--5\\/10': {
        display: 'block',
        maxWidth: '50%',
        flexBasis: '50%'
      },

      '&--6\\/10': {
        display: 'block',
        maxWidth: '60%',
        flexBasis: '60%'
      },

      '&--7\\/10': {
        display: 'block',
        maxWidth: '70%',
        flexBasis: '70%'
      },

      '&--8\\/10': {
        display: 'block',
        maxWidth: '80%',
        flexBasis: '80%'
      },

      '&--9\\/10': {
        display: 'block',
        maxWidth: '90%',
        flexBasis: '90%'
      },

      '&--10\\/10': {
        display: 'block',
        maxWidth: '100%',
        flexBasis: '100%'
      },

      // gridSize: desktop: 12
      '&--1\\/12': {
        display: 'block',
        maxWidth: '8.333333333333334%',
        flexBasis: '8.333333333333334%'
      },

      '&--2\\/12': {
        display: 'block',
        maxWidth: '16.666666666666668%',
        flexBasis: '16.666666666666668%'
      },

      '&--3\\/12': {
        display: 'block',
        maxWidth: '25%',
        flexBasis: '25%'
      },

      '&--4\\/12': {
        display: 'block',
        maxWidth: '33.333333333333336%',
        flexBasis: '33.333333333333336%'
      },

      '&--5\\/12': {
        display: 'block',
        maxWidth: '41.66666666666667%',
        flexBasis: '41.66666666666667%'
      },

      '&--6\\/12': {
        display: 'block',
        maxWidth: '50%',
        flexBasis: '50%'
      },

      '&--7\\/12': {
        display: 'block',
        maxWidth: '58.333333333333336%',
        flexBasis: '58.333333333333336%'
      },

      '&--8\\/12': {
        display: 'block',
        maxWidth: '66.66666666666667%',
        flexBasis: '66.66666666666667%'
      },

      '&--9\\/12': {
        display: 'block',
        maxWidth: '75%',
        flexBasis: '75%'
      },

      '&--10\\/12': {
        display: 'block',
        maxWidth: '83.33333333333334%',
        flexBasis: '83.33333333333334%'
      },

      '&--11\\/12': {
        display: 'block',
        maxWidth: '91.66666666666667%',
        flexBasis: '91.66666666666667%'
      },

      '&--12\\/12': {
        display: 'block',
        maxWidth: '100%',
        flexBasis: '100%'
      },

      '&--0': {
        display: 'none'
      },

      '&--hidden': {
        display: 'none'
      },

      '&.pff-flexbox-page-column': {
        [`@apply flex-grow max-w-[unset] w-[87.5vw] basis-[87.5vw] md:w-[80vw] md:basis-[80vw] lg:w-[83.33vw] lg:basis-[83.33vw]`]:
          {}
      },

      '&.pff-flexbox-form-container': {
        [`@apply items-center bg-navy-500 rounded-[1.25rem] shadow-[0_3px_6px_#0000004D]
          flex flex-col py-9 lg:py-[3.125rem]`]: {}
      }
    }
  };
};

const getFlexWrapperComponent = () => {
  return {
    '.flex-wrapper': {
      display: 'flex',
      flexDirection: 'column'
    }
  };
};
